export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'S’agit-il d’un produit physique ?',
    answer:
      'Non. DOMOTIQUE PRO™ est un produit 100 % numérique et vous recevrez votre accès après votre achat.',
  },
  {
    question: 'Est-il adapté si je pars complètement de zéro ?',
    answer:
      'Oui. Le système a été spécialement structuré pour vous accompagner progressivement des fondamentaux jusqu’à la conception, l’installation, l’automatisation et l’intégration de systèmes domotiques sans nécessiter de connaissances techniques avancées au départ.',
  },
  {
    question: 'Est-ce uniquement de la théorie sur la domotique ?',
    answer:
      'Non. La théorie permet de comprendre ce que vous faites, mais le système repose sur des applications pratiques, procédures étape par étape, exercices, exemples, checklists, configurations et projets progressifs.',
  },
  {
    question: 'Dois-je déjà connaître Zigbee, Matter, Thread, Jeedom ou Home Assistant ?',
    answer:
      'Non. Ces technologies sont introduites progressivement au moment où elles deviennent nécessaires afin de comprendre d’abord les fondamentaux avant d’aborder les intégrations plus avancées.',
  },
  {
    question: 'Vais-je apprendre à créer des automatisations ?',
    answer:
      'Oui. Vous apprendrez la logique des déclencheurs, conditions et actions et l’appliquerez à l’éclairage, au chauffage, à la sécurité, aux volets, à la présence, au confort, aux routines et à l’efficacité énergétique.',
  },
  {
    question: 'Puis-je utiliser le système pour réaliser de vrais projets ?',
    answer:
      'Oui. Le parcours couvre conception, sélection des appareils, mise en service, automatisations, intégrations, tests, dépannage et documentation avec des projets complets montrant comment organiser chaque étape.',
  },
  {
    question: 'DOMOTIQUE PRO™ remplace-t-il un électricien ou un professionnel qualifié ?',
    answer:
      'Non. Le système enseigne la conception, la configuration, l’automatisation et la gestion de systèmes domotiques. Les interventions électriques ou réglementées nécessitant une qualification spécifique doivent être réalisées par des professionnels qualifiés conformément à la réglementation applicable.',
  },
  {
    question: 'Comment vais-je recevoir mon accès ?',
    answer:
      'Immédiatement après le paiement. Vous recevrez tout par e-mail en quelques minutes.',
  },
  {
    question: 'Combien de temps faut-il pour avancer dans les 6 modules ?',
    answer:
      'Il n’y a aucune limite de temps : l’accès reste disponible et vous avancez à votre rythme. En consacrant quelques heures par semaine, la plupart des utilisateurs terminent les six modules en deux à trois mois en suivant l’ordre du parcours.',
  },
  {
    question: 'Faut-il déjà posséder des appareils connectés pour commencer ?',
    answer:
      'Non. Vous pouvez suivre les modules de fondamentaux et de conception sans aucun matériel, puis choisir vos premiers appareils avec le guide de sélection et compatibilité pour éviter les achats inutiles ou incompatibles.',
  },
]
